import { createAction, props } from '@ngrx/store';
import { IDropDownList } from '@interfaces';
export const loadSpecializations = createAction('[Specializations] Load Specializations');
export const loadSpecializationsSuccess = createAction(
  '[Specializations] Load Specializations Success',
  props<{ specializations: IDropDownList[] }>(),
);
export const loadSpecializationsFailure = createAction(
  '[Specializations] Load Specializations Failure',
  props<{ error: string }>(),
);

export const addSpecializations = createAction(
  '[Specializations] Add Specializations',
  props<{ specializations: IDropDownList }>(),
);
export const removeSpecializations = createAction(
  '[Specializations] Remove Specializations',
  props<{ specializationId: string }>(),
);
export const updateSpecializations = createAction(
  '[Specializations] Update Specializations',
  props<{ specializations: IDropDownList }>(),
);
